import Vue from "vue";
import "./cube-ui";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import api from "@/api/api-list";
import db from "@/assets/js/db";
import filters from "./assets/js/filters";
import VueTouch from "./assets/js/plugins/touch";
import VConsole from "vconsole";
import "@/assets/js/wx-sdk";
import "amfe-flexible";
import VueLazyload from "vue-lazyload";
import { calcSize } from "./assets/js/utils";
import "swiper/swiper-bundle.css";
import VueAwesomeSwiper from "vue-awesome-swiper";
import VueWechatTitle from "vue-wechat-title";
import VueSlider from "vue-slider-component";
import "vue-slider-component/theme/default.css";
import { verifyTrustDevice } from "./assets/js/utils";
import { wxMiniAutoLogin, navigateToWebView, switchToWebView, redirectToWebView } from "./utils/utils";
import Cookies from "js-cookie";

Vue.component("VueSlider", VueSlider);
Vue.use(VueWechatTitle);
Vue.use(VueAwesomeSwiper);
import "./assets/scss/index.scss";
Vue.use(VueLazyload, {
  loading: "https://files.wondercv.com/mobile/cvs/img-empty.png",
});

Vue.prototype.$api = api;
Vue.prototype.$db = db;
Vue.prototype.$fn = {
  jump: navigateToWebView,
  switch: switchToWebView,
  redirect: redirectToWebView
};
Vue.config.productionTip = false;
Vue.prototype.$eventBus = new Vue();
window.addEventListener("resize", calcSize);

wxMiniAutoLogin();

// 挂载监听手机返回物理按键方法
// 监听事件
const phoneCallBack = (fn) => {
  if (window.history && window.history.pushState) {
    history.pushState(null, null, document.URL);
    window.addEventListener("popstate", fn, false);
  }
};

if (process.env.VUE_APP_ENV !== "prod") {
  const vConsole = new VConsole();
}

if (
  window.location.href.includes("awAutoLogin") &&
  process.env.VUE_APP_ENV === "local"
) {
  const JWT =
    "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJVc2VyIjp7InQiOiJmNWI0MzNiNjdmY2Q0ZTI3YmZlMzRkOGEwNDdiOTUzOSIsImNfdCI6ImN2ZTU1Y2Q2ODkwNWZlNGNjIiwiaF90IjoiIn0sImV4cCI6MTczODU3MDQ2OX0._sSGQtyL6zTMK-Is72ooLi_S3FlQQsYhfK9t1FuxIfE";
  Cookies.set("_t", JWT);
}

// 销毁监听

const nullCallBack = (fn) => {
  window.removeEventListener("popstate", fn, false);
};

Vue.prototype._phoneCallBack = phoneCallBack;
Vue.prototype._nullCallBack = nullCallBack;

if (process.env.VUE_APP_ENV !== "local") {
  verifyTrustDevice();
}

// 增加sentry上报插件
// import * as Sentry from '@sentry/browser'
// import * as Integrations from '@sentry/integrations'
// "@sentry/browser": "^5.15.5",
//     "@sentry/integrations": "^5.15.5",
//     "@sentry/webpack-plugin": "^1.10.0",
// 初始化sentry

// const VERSION = require('../version')
// const SentryDsn = process.env.VUE_APP_EVN === 'dev' ?
// 	'' :
// 	(process.env.VUE_APP_ENV === 'staging' ? 'https://6e6c696e042c4db79c40c790f1c7212e@staging-sentry.wondercv.cn/8' : 'https://44e4330bb83044c8b82ccb1ad83a51fd@sentry.wondercv.cn/4')
// console.log('main Sentry.init release=>', VERSION.release, SentryDsn)
// if (process.env.NODE_ENV === 'production') {
// 	Sentry.init({
// 		release: VERSION.release,
// 		dsn: SentryDsn,
// 		// debug:true,
// 		// logErrors: true,
// 		integrations: [
// 			new Integrations.Vue({
// 				Vue,
// 				attachProps: true // 是否上报组件的 props
// 			}),
// 			new Integrations.RewriteFrames() //<-----新增
// 		],
// 		// beforeSend(event, hint) {
// 		//     // Check if it is an exception, and if so, show the report dialog
// 		//   if (event.exception) {
// 		//     Sentry.showReportDialog({ eventId: event.event_id });
// 		//   }
// 		//   return event;
// 		// }
// 	})
// 	window.Sentry = Sentry
// 	console.log('Sentry=>', Sentry)

// }

// 定义全局的filter
Object.keys(filters).forEach((i) => {
  Vue.filter(i, filters[i]);
});
Vue.use(VueTouch);
Vue.config.ignoredElements = [
  "wx-open-launch-app",
  "wx-open-subscribe",
  "wx-open-launch-weapp",
];

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
